/* eslint-disable no-unused-vars */
import { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import InputBase from "@mui/material/InputBase";
import { FormControl, FormHelperText, InputLabel } from "@mui/material";
import useTailwindBrand from "../../Theme/useTailwindBrand";


// const TeachrInput = styled(InputBase, {
//   shouldForwardProp: (prop) => prop !== 'notched',
// })(() => ({
//   "& .MuiInputBase-input": {
//     borderRadius: 4,
//     position: "relative",
//     backgroundColor: 'transparent',
//     border: "none",
//     padding: "0",
//   },
// }));

interface PropsFormSelect {
  defaultValue: number | string,
  callback: (value: number) => void,
  customClass?: string
  label?: string
  placeholders?: string
  placeholder?: string
  data: string[],
  required?: boolean,
  error?: string | undefined
  multiple?: boolean,
}

function FormSelect(props: PropsFormSelect) {
  const { classes, brandConfig } = useTailwindBrand()
  const dataLength = props?.data?.length ?? 0
  const normalizeValue = (raw: number | string): number | "" => {
    if (raw === undefined || raw === null) return ""
    if (typeof raw === "number" && raw >= 1 && raw <= dataLength) return raw
    if (typeof raw === "string" && props?.data?.length) {
      const idx = props.data.indexOf(raw)
      if (idx >= 0) return idx + 1
    }
    return ""
  }
  const [value, setValue] = useState<number | "">(() => normalizeValue(props?.defaultValue ?? ""));

  useEffect(() => {
    if (props?.defaultValue !== undefined && props?.data?.length) {
      const raw = props.defaultValue;
      const next =
        typeof raw === "number" && raw >= 1 && raw <= props.data.length
          ? raw
          : typeof raw === "string"
            ? (() => {
                const idx = props.data.indexOf(raw);
                return idx >= 0 ? idx + 1 : "";
              })()
            : "";
      setValue(next);
    }
  }, [props?.defaultValue, props?.data]);

  const handleChange = (event: SelectChangeEvent<string | number>) => {
    const { value } = event.target;
    setValue(value as number);
    props?.callback(value as number);
  };
  return (
    <div>
      <FormControl variant="filled" fullWidth >
        <InputLabel required={props.required} className={`${classes.fontFamily} ${props.error ? classes.error : classes.text} font-semibold [&_.MuiFormLabel-asterisk]:text-red-700`}>{props.label}</InputLabel>
        <Select
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          // placeholder={props.placeholder}
          value={value}
          onChange={handleChange}
          className={`${classes.fontFamily} ${props.error ? classes.errorBorder + ' border-l-4' : 'border-gray-400'} bg-white rounded-md border `}
          sx={{
            fontFamily: brandConfig.fontFamily,
          }}
        >
          {props.placeholder && <MenuItem value=""><em>{props.placeholder}</em></MenuItem>}
          {props?.data.map((el: string, key: number) => (
            <MenuItem
              sx={{
                '&.MuiMenuItem-root': {
                  fontFamily: brandConfig.fontFamily
                }
              }} key={key} value={key + 1}>{el}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormHelperText className={`${classes.fontFamily} ${classes.error} italic font-semibold`}>{props.error}</FormHelperText>
    </div>
  );
}
export default FormSelect;
